import { LessonComment } from "../models";

export const filterLiveStreamChatMessages = (
	streamComments: LessonComment[],
	newMessage: LessonComment
): LessonComment[] => {
	const oldComments = [...streamComments];
	const newComment = newMessage;
	const index = oldComments.findIndex(item => item.id === newComment.id);

	if (newComment.isDeleted) {
		if (index !== -1) {
			oldComments.splice(index, 1); // remove the existing item
		}
	} else {
		if (index !== -1) {
			oldComments[index] = newComment; // update existing item
		} else {
			oldComments.unshift(newComment); // add new item
		}
	}
	return oldComments;
};
